export function getAll() {
  return [
    {
      value: 0,
      name: "SameTerminal",
      text: "同收銀台",
    },
    {
      value: 1,
      name: "SameStore",
      text: "同門市",
    },
    {
      value: 2,
      name: "All",
      text: "全部",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
